import { useNavigationState } from '@react-navigation/native';

// Back button labels by parent screen. Screen falls back to these when a page passes no backLabel.
const BACK_LABELS = {
	Home: 'Home',
	AllRunsView: 'All Runs',
	ServiceRunListView: 'Service runs',
	ServiceRunDetailView: 'Service run',
	WarehouseView: 'Warehouse',
	StocktakeListView: 'Stocktakes',
	StockDeliveryListView: 'Stock deliveries',
	PendingStockListView: 'Pending stock',
	SetupsView: 'Setups',
	TicketListView: 'Tickets',
	PointOfSaleListView: 'Points of sale',
	MyAccountView: 'My account',
	ProcedureListView: 'Procedures',
	TrainingListView: 'Training',
	StartOfDayView: 'Start of day',
	EndOfDayView: 'End of day',
	StopView: 'Stop',
	DocketDetailView: 'Stop',
	PickListSummaryView: 'Pick list summary',
	PickingMyDayView: 'Picking My Day',
	RunListView: 'Run',
	RunOverviewView: 'Run overview',
};

// Label of the previous stack screen for the redesign header ("< Stop"), or
// undefined for a plain back chevron.
const useBackLabel = () => useNavigationState(state => (
	state?.index > 0 ? BACK_LABELS[state.routes[state.index - 1]?.name] : undefined
));

export default useBackLabel;
